var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2.5","d":"M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}})}
var staticRenderFns = []

export { render, staticRenderFns }